import React from "react";
import { RadioGroup as MuiRadioGroup } from "@mui/material";

export const RadioGroup = ({
  value,
  onChange,
  children,
  defaultValue,
  name,
  ariaLabel,
}) => (
  <MuiRadioGroup
    {...{ value, onChange, defaultValue, name, "aria-label": ariaLabel }}
  >
    {children}
  </MuiRadioGroup>
);
